import {
  DEFAULT_LOGO_SIZE
} from '~js/constants'
import {
  xmlUrlString
} from '~js/helpers'

function getCompassImage (locale) {
  let compassImage = ''
  switch (locale) {
    case 'zh-tw':
      compassImage = require('../img/compass/compass-zh-tw.png')
      break
    case 'zh-cn':
      compassImage = require('../img/compass/compass-zh-cn.png')
      break
    default:
      compassImage = require('../img/compass/compass-en.png')
      break
  }
  return compassImage
}

// 這裡的設定都只針對第一個全景圖的設定，後續切換全景圖的 topLogo、指南針角度 操作都在 actions.js 裡面，
// size: 0% ~ 100%
function setLogoTripodSize (logoSize = DEFAULT_LOGO_SIZE, hasCompass) {
  if (window.isNaN(logoSize) || logoSize <= 0) {
    return 0
  }
  const ratio = hasCompass ? 0.67 : 1
  return (logoSize / 100) * ratio
}

const getLogoTripodXml = (image, logoSize, showTop = false, compassConfig = {}) => {
  let tripodXml = ''

  const {
    compass,
    firstCompassDegree,
    locale
  } = compassConfig
  const showCompass = firstCompassDegree !== undefined

  if (compass) {
    tripodXml += `<hotspot name="compassTripod" keep="true" url="${xmlUrlString(getCompassImage(locale))}" ath="0" atv="90"
distorted="true" width="650" height="650" rotate="${firstCompassDegree}" visible="${showCompass}" enabled="false" />`
  }
  // 由 editor 上傳時來決定圖片不超過寬高 600
  tripodXml += `<hotspot name="logoTripod" keep="true" url="${xmlUrlString(image)}" ath="0" atv="90"
distorted="true" scale="${setLogoTripodSize(logoSize, compass)}" enabled="false" />
<hotspot name="topLogoTripod" keep="true" url="${xmlUrlString(image)}" ath="0" atv="-90" distorted="true"
 scale="${setLogoTripodSize(logoSize, compass)}" visible="${showTop}" enabled="false" />`

  return tripodXml
}

export default getLogoTripodXml
